module.exports = __webpack_public_path__ + "img/login_1.a9afd894.png";